/**
 * @generated SignedSource<<4b810757fd5d7fbbe06662a64c93f9e8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppAccessRouterQuery$variables = {
  appId: string;
};
export type AppAccessRouterQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly viewerCanCreateApiKey: boolean;
    } | null | undefined;
  };
};
export type AppAccessRouterQuery = {
  response: AppAccessRouterQuery$data;
  variables: AppAccessRouterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanCreateApiKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppAccessRouterQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppAccessRouterQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "97854fc11db158509b50ad0b54ce2bd0",
    "id": null,
    "metadata": {},
    "name": "AppAccessRouterQuery",
    "operationKind": "query",
    "text": "query AppAccessRouterQuery(\n  $appId: ID!\n) {\n  viewer {\n    appById(id: $appId) {\n      viewerCanCreateApiKey\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "79ad0cddfea3b80433a649a699ca52e7";

export default node;
